export default "__VITE_ASSET__BWNbg527__"